import { xs_languageCode } from "../..";
import { splitHandicap } from "../splitHandicap";

const betIds = [26842, 26843];

export function specialHandling(bet) {
    try {
        if (betIds.includes(bet.cs)) {
            const result = splitHandicap(bet.h, bet.th, bet.eqs, bet.dia, xs_languageCode, bet.ia);
            return `${result.info1}-${result.info2} ${result.info3}-${result.info4}`;
        }
    } catch (e) {
        console.error(e);
    }

    return null;
}
